import { useParams } from 'react-router-dom';
import AddSimulation from './AddSimulation';

const SimulationReview = () => {
  const { simulationId } = useParams();

  return <AddSimulation reviewMode reviewSimulationId={simulationId} />;
};

export default SimulationReview;
